import React from 'react'

import { ActionButtonProps } from '@/components/misc/ActionButton'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { cn } from '@/lib/utils'

const PlainActionButton: React.FC<ActionButtonProps> = ({
  isProcessing,
  isProcessingText,
  showIsProcessingText,
  children,
  className,
  ...props
}) => {
  const shouldShowProcessingText = isProcessing && showIsProcessingText

  return (
    <Button
      variant="plain"
      className={cn(className)}
      disabled={isProcessing}
      style={{ opacity: isProcessing ? '0.6' : '1' }}
      {...props}
    >
      {shouldShowProcessingText ? isProcessingText : children}

      {isProcessing && <Spinner />}
    </Button>
  )
}

export default PlainActionButton
